export default {
  total_orders: {
    title: 'Ordrer',
    orders: 'Ordrer:',
    sales_volume: 'Salgsvolumen:',
    delivery_costs: 'Leveringsomkostninger:',
  },
  cash_orders: {
    title: 'Betaling med kontanter/ved døren',
    orders: 'Ordrer:',
    sales_volume: 'Salgsvolumen:',
    delivery_costs: 'Leveringsomkostninger:',
  },
  online_orders: {
    title: 'Onlinebetalinger',
    orders: 'Ordrer:',
    sales_volume: 'Salgsvolumen:',
    delivery_costs: 'Leveringsomkostninger:',
  },
  total: 'I alt',
  collected_taxes_list: {
    title: {
      online: 'Onlinebetaling',
      cash: 'Kontantbetaling',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Produkt',
          quantity: 'Antal',
          total: 'I alt',
        },
        labels: {
          total_refunded: 'Refunderet',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'Moms %',
          product_type: 'Type',
          netto: 'Netto',
          tax: 'Moms',
          brutto: 'I alt',
        },
        product_types: {
          product: 'Produkter {{percentage}}%',
          order_method_fee: 'Leveringsgebyrer {{percentage}}%',
          customer_service_fee: 'Onlinetillæg',
        },
      },
    },
  },
};
